import {HttpContext, HttpContextToken} from '@angular/common/http';
import moment from 'moment';

export const BYPASS_INTERCEPTOR_CONTEXT_TOKEN = new HttpContextToken(() => true);
export const DO_NOT_BYPASS_INTERCEPTOR_CONTEXT = new HttpContext().set(BYPASS_INTERCEPTOR_CONTEXT_TOKEN, false);

export const INTERCEPTOR_SKIP = 'X-Skip-Interceptor';
export const POLISH_DATE_FORMAT = 'DD.MM.YYYY';

export const DATEPICKER_DATE_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: POLISH_DATE_FORMAT,
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

moment.fn.toJSON = function() {
  const iso = moment(this).toISOString(true);
  return iso.slice(0, -6);
};

moment.fn.toString = function() {
  const iso = moment(this).toISOString(true);
  return iso.slice(0, -10);
};

export const X_XSRF_TOKEN_NAME = ('XSRF-TOKEN');
export const PAGE_SIZE_OPTIONS = [10, 50, 100];
export const DEFAULT_PAGE_SIZE = 50;

export enum LEGAL_CASE_VIEW {
  ROW = ('row'),
  ROW_REVERSE = ('row-reverse'),
  COLUMN = ('column'),
  COLUMN_REVERSE = ('column-reverse')
}
